import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CloseImage from '../../assets/ic_close.png';
import { useStyles, BootstrapInput } from '../../library/selectOption'; 


export default function FilterDocter(props) {
    const classes = useStyles();
    const [spesialis, setSpesialis] = React.useState("spesialis");
    const [pengalamanDokter, setPengalamanDokter] = React.useState(Number)
    console.log(pengalamanDokter, spesialis);
    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: '33%' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Filter Data</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, height: 400 }}>
                    <div className="column-1">
                        <div className="">
                            <FormControl className={classes.margin} style={{width: "100%"}}>
                                <InputLabel id="demo-customized-select-label">Spesialis/ Poliklinik</InputLabel>
                                <Select
                                labelId="demo-customized-select-label"
                                label="Spesialis/ Poliklinik"
                                id="demo-customized-select"
                                value={spesialis}
                                onChange={(e) => setSpesialis(e.target.value)}
                                input={<BootstrapInput />}
                                >
                                <MenuItem disabled={true}>
                                    <em>--spesialis--</em>
                                </MenuItem>
                                <MenuItem value={"mata"}>Mata</MenuItem>
                                <MenuItem value={"tht"}>THT</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl className={classes.margin} style={{width: "100%"}}>
                                <InputLabel id="demo-customized-select-label">Pengalaman Dokter</InputLabel>
                                <Select
                                labelId="demo-customized-select-label"
                                label="Pengalaman Dokter"
                                id="demo-customized-select"
                                value={pengalamanDokter}
                                onChange={(e) => setPengalamanDokter(e.target.value)}
                                input={<BootstrapInput />}
                                >
                                <MenuItem disabled={true}>
                                    <em>--umur pasien--</em>
                                </MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}